import { createSlice } from "@reduxjs/toolkit";
import { GuestLogin } from "../types/GuestLoginType";
import { appAccessOTPVerify } from "../action/appAccessOTPVerify";

const initialState: GuestLogin = {
  data: null,
  loading: false,
  error: null,
  // successfull: false,
};

const guestSendAppAccessOTP = createSlice({
  name: "guestSendAppAccessOTP",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(appAccessOTPVerify.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(appAccessOTPVerify.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(appAccessOTPVerify.rejected, (state, action) => {
        state.loading = false;
        state.error = `${action.payload}`;
      });
  },
});

export const guestSendAppAccessOTPReducer = guestSendAppAccessOTP.reducer;
